import { Injectable } from '@angular/core';
import { AbsPaginatedGrid } from 'src/app/app.models';
import { QueryParams_LogVariableEnvironnementUser } from 'src/app/pages/views/settings/variable-environment/variable-environment.service';

@Injectable()
export abstract class LogVariableEnvironnementUserService {
    abstract doBuildGridAction(_queryParams: QueryParams_LogVariableEnvironnementUser): Promise<AbsPaginatedGrid<any>>;
}